module.exports = "/_next/static/images/ExtraInfo@2x-d8e7f196ce20c78ea8e51b40a3d85638.png";